import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=1b980734&scoped=true"
import script from "./Totals.vue?vue&type=script&lang=ts"
export * from "./Totals.vue?vue&type=script&lang=ts"
import style0 from "./Totals.vue?vue&type=style&index=0&id=1b980734&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b980734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b980734')) {
      api.createRecord('1b980734', component.options)
    } else {
      api.reload('1b980734', component.options)
    }
    module.hot.accept("./Totals.vue?vue&type=template&id=1b980734&scoped=true", function () {
      api.rerender('1b980734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/Totals.vue"
export default component.exports